export const faqConstants = {
  GET_FAQ_SUCCESS: "GET_FAQ_SUCCESS",
  SHOW_FAQ_SUCCESS: "SHOW_FAQ_SUCCESS",
  UPDATE_FAQ_SUCCESS: "UPDATE_FAQ_SUCCESS",
  ADD_FAQ_SUCCESS: "ADD_FAQ_SUCCESS",
  STORE_FAQ_SUCCESS: "STORE_FAQ_SUCCESS",
  REMOVE_FAQ_SUCCESS: "REMOVE_FAQ_SUCCESS",
  GET_FAQ_SECTIONS_SUCCESS: "GET_FAQ_SECTIONS_SUCCESS",
  ADD_FAQ_SECTION_SUCCCESS: "ADD_FAQ_SECTION_SUCCCESS",
  REMOVE_FAQ_SECTION_SUCCESS: "REMOVE_FAQ_SECTION_SUCCESS",
  UPDATE_FAQ_SECTION_SUCCESS: "UPDATE_FAQ_SECTION_SUCCESS",
  ADD_FAQ_SECTION__DETAILS_SUCCCESS: "ADD_FAQ_SECTION__DETAILS_SUCCCESS",
  REMOVE_FAQ_DETAIL_SUCCESS: "REMOVE_FAQ_DETAIL_SUCCESS",
  UPDATE_FAQ_SECTION_DETAIL_SUCCESS: "UPDATE_FAQ_SECTION_DETAIL_SUCCESS",
};
